import { JVDropdown } from "../../../shared/JVDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVInput } from "../../../shared/JVInput";
import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IRequirementMast } from "../../../models/RequirementMast";
import { Button } from "primereact/button";
import { POConsultantRateHistory } from "./POConsultantRateHistory";
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { IBranchMastDropdown } from "../../../models/IDropdown";
import { ILogin } from "../../../models/Login";
import { Dialog } from "primereact/dialog";
import { RateChangeDialog } from "./RateChangeDialog";

interface Iprops {
  po: IPurchaseOrder;
  toast: any;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  setNeedtoReload: (reload: boolean) => void;
}

export interface IModel2 {
  open: boolean;
  singleData: any;
}

const schema = yup.object({
  // bRate: yup.number().required("B Rate is required").typeError("B Rate is required"),
  // sRate: yup.number().required("S Rate is required").typeError("S Rate is required"),
  //bRate: yup.number().nullable(),
  // sRate: yup.number().nullable(),
  mRate: yup.number().required("M Rate is required").typeError("M Rate is required"),
  // branch_Name: yup.string().required("Branch is required").typeError("Branch is required"),
  // brancPer: yup.number().required("This field is required").typeError("This field is required"),
  // headOffPer: yup.number().required("This field is required").typeError("This field is required"),
  pV_Referal: yup.boolean().nullable(),
  both: yup.boolean().nullable(),
  salesBranchPer: yup.number().required("This field is required").typeError("This field is required"),
  recBranchPer: yup.number().required("This field is required").typeError("This field is required"),
  homeBranchPerA: yup.number().required("This field is required").typeError("This field is required"),
  homeBranchPerB: yup.number().required("This field is required").typeError("This field is required"),
  recruiterBranchID: yup.number().nullable(),
  salesBranchID: yup.number().nullable(),
  w2_Percentage: yup.number().nullable(),
  w2_Doller_Rate: yup.number().nullable(),
  w2_Referral_Rate: yup.number().nullable(),
  discount_Percentage: yup.number().nullable(),
  changeDirect: yup.boolean().nullable(),
});

export const PositionInformation = (props: Iprops) => {
  const [loading, setLoading] = useState(false);
  const [label, setLabel] = useState("Agra");
  const [reqData, setReqData] = useState<IRequirementMast>();
  const [branch, setBranch] = useState<Array<IBranchMastDropdown>>();
  const [isW2Rate, setIsW2Rate] = useState(false);

  // 2. Add state for dialog and pending data
  const [showRateChangeDialog, setShowRateChangeDialog] = useState(false);
  const [pendingSubmitData, setPendingSubmitData] = useState<IPurchaseOrder | null>(null);
  const [originalRates, setOriginalRates] = useState<{ bRate: any; sRate: any; mRate: any }>({
    bRate: null,
    sRate: null,
    mRate: null,
  });
  const originalRatesSet = useRef(false);
  const branches = [{ name: "Noida" }, { name: "Agra" }, { name: "Bhubaneswar" }, { name: "Ranchi" }, { name: "Meerut" }, { name: "Varanasi" }, { name: "Agra-Noida" }, { name: "Varanasi-Noida" }, { name: "Varanasi-Agra" }];

  const [modal2, setModal2] = useState({ singleData: {}, open: false, load: false } as any);
  const hideDialog2 = () => {
    setModal2({ singleData: {}, open: false, load: false });
  };

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm<IPurchaseOrder>({
    resolver: yupResolver(schema),
    defaultValues: {
      bRate: props.po.bRate,
      sRate: props.po.sRate,
      mRate: props.po.mRate,
      branch_Name: props.po.branch_Name,
      brancPer: props.po.brancPer,
      headOffPer: props.po.headOffPer,
      pV_Referal: props.po.pV_Referal === true && props.po.sV_Referals === true ? false : props.po.pV_Referal || false,
      sV_Referals: props.po.pV_Referal === true && props.po.sV_Referals === true ? false : props.po.sV_Referals || false,
      both: props.po.pV_Referal === true && props.po.sV_Referals === true ? true : false,
      is_W2: props.po.is_W2,
      w2_Percentage: props.po.w2_Percentage,
      w2_Doller_Rate: props.po.w2_Doller_Rate,
      w2_Referral_Rate: props.po.w2_Referral_Rate,
      is_Discount: props.po.is_Discount,
      discount_Percentage: props.po.discount_Percentage,
      changeDirect: false,
    },
    shouldFocusError: false,
  });
  // console.log(props.po.sRate)
  // const isLinkUser = watch("pV_Referal");
  // const isLinkUserSV = watch("sV_Referals");
  // const isPVSelected = watch("pV_Referal");
  // const isSVSelected = watch("sV_Referals");
  const w2RateSelected = watch("is_W2");
  const isDiscountSelected = watch("is_Discount");

  const methodSetLabel = (branch: string) => {
    if (branch === "Noida") setLabel("None");
    else if (branch === "Agra") setLabel("Agra");
    else if (branch === "Varanasi") setLabel("Varanasi");
    else if (branch === "Agra-Noida") setLabel("Agra");
    else if (branch === "Varanasi-Noida") setLabel("Varanasi");
    else if (branch === "Varanasi-Agra") setLabel("Varanasi-Agra");
  };
  const setLabelValue = (branch: string) => {
    if (branch === "Noida") {
      setValue("brancPer", 0);
      setValue("headOffPer", 100);
    } else if (branch === "Agra") {
      setValue("brancPer", 70);
      setValue("headOffPer", 30);
    } else if (branch === "Varanasi") {
      setValue("brancPer", 70);
      setValue("headOffPer", 30);
    } else if (branch === "Agra-Noida") {
      setValue("brancPer", 50);
      setValue("headOffPer", 50);
    } else if (branch === "Varanasi-Noida") {
      setValue("brancPer", 50);
      setValue("headOffPer", 50);
    } else if (branch === "Varanasi-Agra") {
      setValue("brancPer", 70);
      setValue("headOffPer", 30);
    }
  };

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (name === "branch_Name" && value.branch_Name) {
        methodSetLabel(value.branch_Name);
        setLabelValue(value.branch_Name);
      }
      if (name === "bRate" || name === "sRate") {
        if (value.bRate != 0 && value.bRate != null && value.sRate != 0 && value.sRate != null && control._formValues.both === true) {
          setValue("mRate", Number(control._formValues.sRate || 0) + Number(value.bRate || 0));
        } else if (value.bRate != 0 && value.bRate != null && value.sRate != 0 && value.sRate != null) {
          control._formValues.mRate = control._formValues.sRate - value.bRate;
          setValue("mRate", control._formValues.sRate - value.bRate);
        } else if (value.bRate != 0 && value.bRate != null) {
          control._formValues.mRate = value.bRate;
          setValue("mRate", value.bRate);
        } else if (value.sRate != 0 && value.sRate != null) {
          control._formValues.mRate = control._formValues.sRate - 0;
          setValue("mRate", control._formValues.sRate - 0);
        }
      }
      if (name === "both") {
        if (value.both === true) {
          setValue("pV_Referal", false);
          setValue("sV_Referals", false);
          setValue("mRate", Number(control._formValues.bRate || 0) + Number(control._formValues.sRate || 0));
        }
      }
      if (name === "pV_Referal") {
        if (value.pV_Referal === true) {
          setValue("both", false);
          setValue("sV_Referals", false);
        }
      }
      if (name === "sV_Referals") {
        if (value.sV_Referals === true) {
          setValue("both", false);
          setValue("pV_Referal", false);
        }
      }
      // if (name === "is_W2") {
      //     if (value.is_W2 === true) {
      //         setValue('is_W2', true);
      //     }
      // }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const loadReqData = async () => {
    const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.po.req_ID}`, props.toast);
    if (response) {
      const data: IRequirementMast = await response.json();
      setReqData(data);
    }
  };
  useEffect(() => {
    if (props.po.req_ID) loadReqData();
    if (props.po.branch_Name) methodSetLabel(props.po.branch_Name);
  }, [props.po.req_ID, props.po.branch_Name]);

  const saveToDB = async (body: IPurchaseOrder) => {
    setLoading(true);
    const changeDirectNumber = body.changeDirect === true ? 1 : 0;
    delete body.changeDirect;
    body.pO_ID = props.po.pO_ID;
    const response = await Fetch("vwPODetails/details", "POST", body, `tb=${1}&changeDirect=${changeDirectNumber}`, props.toast);
    if (response) {
      props.toast.current.show({ severity: "success", content: "Saved Successfully" });
      props.setActiveIndex(props.activeIndex + 1);
      props.setNeedtoReload(true);
    }
    setLoading(false);
  };
  function onSubmit(data: any) {
    const hasRateChange = data.bRate !== originalRates.bRate || data.sRate !== originalRates.sRate || data.mRate !== originalRates.mRate;
    if (Number(data.bRate || "0") > Number(data.sRate || "0")) {
      props.toast.current.show({ severity: "error", content: "Buying Rate Can Not Be Greater Than Submission Rate" });
    }
    else if (props.po.pO_Status === "To Join" && hasRateChange === true && data.mRate < originalRates.mRate) {
      setPendingSubmitData(data);
      setShowRateChangeDialog(true);
      return;
    } else {
      if (data.is_W2 === true) {
        if (data.w2_Percentage == null || data.w2_Percentage == "") {
          props.toast.current.show({ severity: "error", content: "W2 Percentage is required" });
          return;
        }
        if (data.w2_Doller_Rate == null || data.w2_Doller_Rate == "") {
          props.toast.current.show({ severity: "error", content: "W2 Dollar Rate is required" });
          return;
        }
      } else if (data.sV_Referals === true && data.pV_Referal === false && data.both === true) {
        data.mRate = Number(data.bRate || 0);
        data.both = false;
      } else if (data.pV_Referal === true && data.sV_Referals === false && data.both === true) {
        data.mRate = Number(data.sRate || 0);
        data.both = false;
      }
      if (data.both) {
        data.mRate = Number(data.bRate || 0) + Number(data.sRate || 0);
        data.sV_Referals = true;
        data.pV_Referal = true;
      }
      delete data.both;

      const errors: Record<string, string> = {};
      if (data.sRate == null || data.sRate == "") {
        data.sRate = null;
      }
      if (data.bRate == null || data.bRate == "") {
        data.bRate = null;
      }

      if ((data.pV_Referal == false || data.pV_Referal == null) && (data.sV_Referals == null || data.sV_Referals == false)) {
        if (data.bRate == null) {
          props.toast.current.show({ severity: "error", content: "B Rate is required" });
          errors.bRate = "B Rate is required";
        } else if (data.sRate == null || data.sRate == "") {
          data.sRate = null;
          props.toast.current.show({ severity: "error", content: "S Rate is required" });
          errors.sRate = "B Rate is required";
        } else {
          saveToDB(data);
          // proceedOrConfirm(data);
        }
      } else if (data.pV_Referal == true) {
        if (data.sRate == null || data.sRate == "") {
          data.sRate = null;
          props.toast.current.show({ severity: "error", content: "S Rate is required" });
          errors.sRate = "B Rate is required";
        } else {
          saveToDB(data);
          // proceedOrConfirm(data);
        }
      } else if (data.sV_Referals == true) {
        if (data.bRate == null) {
          props.toast.current.show({ severity: "error", content: "B Rate is required" });
          errors.bRate = "B Rate is required";
        } else {
          saveToDB(data);
        }
      } else {
        saveToDB(data);
      }
    }
  }

  const ShowPOConsultantRateHistory = () => {
    setModal2({ singleData: { ...props.po }, open: true, load: true });
  };

  // useEffect(() => {
  //     // if (isPVSelected && isSVSelected) {
  //     //     setValue("mRate", (control._formValues?.bRate + control._formValues?.sRate));
  //     // }
  //     if (isPVSelected) {
  //         setValue("sV_Referals", false); // Uncheck Sub PV Referral if PV Referral is selected
  //     }
  //     if (isSVSelected) {
  //         setValue("pV_Referal", false); // Uncheck PV Referral if Sub PV Referral is selected
  //     }
  // }, [isPVSelected, isSVSelected, setValue]);

  const loadBranch = async (company?: number | null | undefined) => {
    let queryParam = company ? `company_id=${company}` : null;
    const response = await Fetch("Dropdown/filterBranchList", "GET", null, queryParam, null);
    if (response) {
      const data: Array<IBranchMastDropdown> = await response.json();
      const emptyData = {
        branch_ID: 0,
        branchName: "-- SELECT --",
        company_ID: 0,
      };
      data.unshift(emptyData);
      setBranch(data);
    }
  };

  useEffect(() => {
    loadBranch();
    if (props?.po?.pO_ID) {
      setValue("recruiterBranchID", props.po.salesBranchID);
      setValue("salesBranchID", props.po.recruiterBranchID);

      // console.log(props.po);
      // reset({
      //     bRate: props.po.bRate,
      //     sRate: props.po.sRate,
      //     mRate: props.po.mRate,
      //     branch_Name: props.po.branch_Name,
      //     brancPer: props.po.brancPer,
      //     headOffPer: props.po.headOffPer,
      //     pV_Referal: props.po.pV_Referal || false,
      //     sV_Referals: props.po.sV_Referals || false
      // });
      const abcdef = () => {
        /*
                1	TEK Inspirations LLC
              2	Vyze INC
              3	GVR Infotek
              4	Adventa Tech Inc
              5	TekIT Pro
              6	Vyze2 INC
              7	Vizon Inc
              8	Jobvritta Inc
              9	Talent Aura Inc
                */

        let HB1 = 1; // Home Banch 1 : Noida ( TEK )
        let HB2 = [8, 16]; // Home Banch 2 : Bhubaneswar ( VYZE )
        let HB1bs = [1, 3, 4, 6, 15]; // Home Banch 1 Franchise Banchs
        let HB2bs = [7, 8, 12, 13, 16, 19, 21, 22, 23, 24, 25, 11, 17, 26]; // Home Banch 2 Franchise Banchs

        let sales = props.po.salesBranchID || 0; // Sales Branch ID
        let recruiter = props.po.recruiterBranchID || 0; // Recruiters Branch ID

        // If sales and recruiter come in Home Banch 1
        if (HB1bs.find((e) => e === sales) !== undefined && HB1bs.find((e) => e === recruiter) !== undefined) {
          if (HB1 === sales && HB1 === recruiter) {
            // give 100% to HB1

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 100);
            setValue("homeBranchPerB", 0);
          } else if (HB1 === sales && HB1 !== recruiter) {
            // give 65% to HB1 and 35% to recruiter

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 65);
            setValue("homeBranchPerB", 0);
          } else if (HB1 !== sales && HB1 === recruiter) {
            // give 35% to sales and 65% to HB1

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 65);
            setValue("homeBranchPerB", 0);
          } else if (HB1 !== sales && HB1 !== recruiter) {
            // give 35% to sales and 35% to recruiter and 30% to HB1

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 30);
            setValue("homeBranchPerB", 0);
          }
        }

        // If sales and recruiter come in Home Banch 2
        if (HB2bs.find((e) => e === sales) !== undefined && HB2bs.find((e) => e === recruiter) !== undefined) {
          if (HB2.includes(sales) && HB2.includes(recruiter)) {
            // give 100% to HB2

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 0);
            setValue("homeBranchPerB", 100);
          } else if (HB2.includes(sales) && !HB2.includes(recruiter)) {
            // give 65% to HB2 and 35% to recruiter

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 0);
            setValue("homeBranchPerB", 65);
          } else if (!HB2.includes(sales) && HB2.includes(recruiter)) {
            // give 35% to sales and 65% to HB2

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 0);
            setValue("homeBranchPerB", 65);
          } else if (!HB2.includes(sales) && !HB2.includes(recruiter)) {
            // give 35% to sales and 35% to recruiter and 30% to HB2

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 0);
            setValue("homeBranchPerB", 30);
          }
        }

        // If sales come in Home Banch 1 and recruiter come in Home Banch 2
        if (HB1bs.find((e) => e === sales) !== undefined && HB2bs.find((e) => e === recruiter) !== undefined) {
          if (HB1 === sales && HB2.includes(recruiter)) {
            // give 50% to HB1 and 50% to HB2

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 50);
            setValue("homeBranchPerB", 50);
          } else if (HB1 !== sales && HB2.includes(recruiter)) {
            // give 15% to HB1 and 35% to Sales and 50% to HB2

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 15);
            setValue("homeBranchPerB", 50);
          } else if (HB1 === sales && !HB2.includes(recruiter)) {
            // give 50% to HB1 and 35% to recruiter and 15% to HB2

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 50);
            setValue("homeBranchPerB", 15);
          } else if (HB1 !== sales && !HB2.includes(recruiter)) {
            // give 35% to sales and 15% to HB1 and 35% to recruiter and 15% to HB2

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 15);
            setValue("homeBranchPerB", 15);
          }
        }

        // If sales come in Home Banch 2 and recruiter come in Home Banch 1
        if (HB2bs.find((e) => e === sales) !== undefined && HB1bs.find((e) => e === recruiter) !== undefined) {
          if (HB2.includes(sales) && HB1 === recruiter) {
            // give 50% to HB2 and 50% to HB1

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 50);
            setValue("homeBranchPerB", 50);
          } else if (!HB2.includes(sales) && HB1 === recruiter) {
            // give 15% to HB2 and 35% to Sales and 50% to HB1

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 0);
            setValue("homeBranchPerA", 50);
            setValue("homeBranchPerB", 15);
          } else if (HB2.includes(sales) && HB1 !== recruiter) {
            // give 50% to HB2 and 35% to recruiter and 15% to HB1

            setValue("salesBranchPer", 0);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 15);
            setValue("homeBranchPerB", 50);
          } else if (!HB2.includes(sales) && HB1 !== recruiter) {
            // give 35% to sales and 15% to HB2 and 35% to recruiter and 15% to HB1

            setValue("salesBranchPer", 35);
            setValue("recBranchPer", 35);
            setValue("homeBranchPerA", 15);
            setValue("homeBranchPerB", 15);
          }
        }
      };
      if (props?.po?.salesBranchPer === null && props?.po?.recBranchPer === null && props?.po?.homeBranchPerA === null && props?.po?.homeBranchPerB === null) {
        abcdef();
      } else {
        setValue("salesBranchPer", props?.po?.salesBranchPer);
        setValue("recBranchPer", props?.po?.recBranchPer);
        setValue("homeBranchPerA", props?.po?.homeBranchPerA);
        setValue("homeBranchPerB", props?.po?.homeBranchPerB);
        setValue("is_W2", props?.po?.is_W2);
        setValue("is_Discount", props?.po?.is_Discount);
      }
    }
  }, [props.po]);

  const sendRateChangeToAPI = async (data: IPurchaseOrder) => {
    const response = await Fetch(
      "Po_Rate_Change/rateChangeRequest",
      "POST",
      {
        pO_ID: props.po.pO_ID,
        p_BRate: Number(originalRates.bRate),
        p_SRate: Number(originalRates.sRate),
        p_MRate: Number(originalRates.mRate),
        r_BRate: Number(data.bRate),
        r_SRate: Number(data.sRate),
        r_MRate: Number(data.mRate),
      },
      null,
      props.toast,
    );
    if (response) {
      props.toast.current.show({ severity: "success", content: "Rate change request submitted. Pending admin approval." });
    }
  };

  const handleConfirmRateChange = async () => {
    setShowRateChangeDialog(false);
    if (pendingSubmitData) {
      await sendRateChangeToAPI(pendingSubmitData);
      setPendingSubmitData(null);
    }
  };

  useEffect(() => {
    if (props.po.pO_ID && !originalRatesSet.current) {
      setOriginalRates({
        bRate: props.po.bRate,
        sRate: props.po.sRate,
        mRate: props.po.mRate,
      });
      originalRatesSet.current = true;
    }
  }, [props.po]);

  return (
    <div className="w-11 m-auto mt-2">
      <div className="grid formgrid">
        <h5 className="field col-12 md:col-4 mt-4">
          Job Title : <span className="text-600 font-light">{reqData?.req_Job_Title}</span>
        </h5>
        <h5 className="field col-12 md:col-4">
          Duration : <span className="text-600 font-light">{reqData?.req_Duration}</span>
        </h5>
        <h5 className="field col-12 md:col-4">
          Location :{" "}
          <span className="text-600 font-light">
            {reqData?.city_Name}, {reqData?.state_Name}
          </span>
        </h5>

        <h5 className="field col-12 md:col-4">
          Req.Type : <span className="text-600 font-light">{reqData?.req_Category_Name}</span>
        </h5>
        <h5 className="field col-12 md:col-4">
          Term : <span className="text-600 font-light">{reqData?.req_Term}</span>
        </h5>
        <h5 className="field col-12 md:col-4">
          Client : <span className="text-600 font-light">{reqData?.vendor_Company_Name}</span>
        </h5>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
        {/* {!isPVSelected && !isSVSelected && <JVInput required column={3} label="Buying Rate" control={control} name="bRate" error={errors.bRate?.message} />}
                {!isPVSelected && !isSVSelected && <JVInput required column={3} label="Submission Rate" control={control} name="sRate" error={errors.sRate?.message} />}
                {isPVSelected && !isSVSelected && <JVInput required column={3} label="Buying Rate" control={control} name="bRate" />}
                {isSVSelected && !isSVSelected && <JVInput column={3} label="Submission Rate" control={control} name="sRate" />} */}
        {<JVInput required column={3} label="Buying Rate" control={control} name="bRate" error={errors.bRate?.message} />}
        {/* {<JVInput column={3} label="Buying Rate" control={control} name="bRate" error={errors.bRate?.message} />} */}

        {<JVInput required column={3} label="Submission Rate" control={control} name="sRate" error={errors.sRate?.message} />}
        {<JVInput column={3} label="Margin" control={control} name="mRate" error={errors.mRate?.message} />}
        {/* <JVCheckbox column={2} label="" control={control} name="pV_Referal" /> */}

        {/* <JVDropdown required column={3} label="Branch" control={control} name="branch_Name" options={branches} optionLabel="name" optionValue="name" placeholder="Select Branch" error={errors.branch_Name?.message} />
                <JVInput required column={3} label={label} control={control} name="brancPer" error={errors.brancPer?.message} />
                <JVInput required column={3} label="Noida" control={control} name="headOffPer" error={errors.headOffPer?.message} /> */}

        <JVDropdown required column={3} label="Sales Branch" control={control} name="recruiterBranchID" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" error={errors.recruiterBranchID?.message} />
        <JVDropdown required column={3} label="Recruiters Branch" control={control} name="salesBranchID" options={branch} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" error={errors.salesBranchID?.message} />
        <JVInput required column={3} label="Sales Franchise Margin" control={control} name="salesBranchPer" error={errors.salesBranchPer?.message} />
        <JVInput required column={3} label="Recruiter Franchise Margin" control={control} name="recBranchPer" error={errors.recBranchPer?.message} />
        <JVInput required column={3} label="Noida Margin" control={control} name="homeBranchPerA" error={errors.homeBranchPerA?.message} />
        <JVInput required column={3} label="Bhubaneswar Margin" control={control} name="homeBranchPerB" error={errors.homeBranchPerB?.message} />
        {w2RateSelected && <JVInput column={3} label="W2 percentage %" control={control} name="w2_Percentage" error={errors.w2_Percentage?.message} />}
        {w2RateSelected && <JVInput column={3} label="W2 Doller Rate" control={control} name="w2_Doller_Rate" error={errors.w2_Doller_Rate?.message} />}
        {w2RateSelected && <JVInput column={3} label="W2 Referral Rate" control={control} name="w2_Referral_Rate" error={errors.w2_Referral_Rate?.message} />}
        {isDiscountSelected && <JVInput column={3} label="Discount %" control={control} name="discount_Percentage" error={errors.discount_Percentage?.message} />}
        <div className="col-12 md:col-12 flex gap-4 mt-3">
          <JVCheckbox column={6} label="Discount %" control={control} name="is_Discount" />
          <JVCheckbox column={6} label="W2" control={control} name="is_W2" />

          <JVCheckbox column={6} label="PV Referral" control={control} name="pV_Referal" />
          <JVCheckbox column={6} label="SV Referral" control={control} name="sV_Referals" />
          <JVCheckbox column={6} label="Both (PV & SV Referral)" control={control} name={"both"} />
        </div>
        <div className="col-12 md:col-12 flex flex-row-reverse gap-2 mt-5">
          <Button type="button" style={{ height: "2.5rem" }} icon="pi pi-history" loading={loading} onClick={ShowPOConsultantRateHistory} tooltip="PO Consultant Rate History" className="p-button-outlined p-button-sm p-button-icon-only"></Button>
          <label htmlFor="">&nbsp;</label>
          <Button style={{ width: "10rem", height: "2.5rem" }} loading={loading} type="submit" label="SAVE & NEXT"></Button>
          <div className="mt-3">{(_roles.includes(1) || _roles.includes(47)) && <JVCheckbox column={1} label="Don't Create New PO" control={control} name="changeDirect" />}</div>
        </div>
      </form>
      <POConsultantRateHistory singleData={modal2.singleData} open={modal2.open} load={modal2.load} hideDialog={hideDialog2} toast={props.toast}></POConsultantRateHistory>

      <RateChangeDialog
        visible={showRateChangeDialog}
        loading={loading}
        pendingSubmitData={pendingSubmitData}
        originalRates={originalRates}
        onConfirm={handleConfirmRateChange}
        onCancel={() => {
          setShowRateChangeDialog(false);
          setPendingSubmitData(null);
        }}
      />
    </div>
  );
};
